import { createFileRoute } from '@tanstack/react-router';
import { SearchResultsBody } from '@/components/global-search/SearchResultsBody';

type SearchPageSearch = {
  q?: string;
  type?: 'all' | 'members' | 'groups' | 'events' | 'resources' | 'posts' | 'messages';
};

function pickStr(v: unknown): string | undefined {
  return typeof v === 'string' && v.length > 0 ? v : undefined;
}

function parseType(v: unknown): SearchPageSearch['type'] {
  return v === 'all' ||
    v === 'members' ||
    v === 'groups' ||
    v === 'events' ||
    v === 'resources' ||
    v === 'posts' ||
    v === 'messages'
    ? v
    : undefined;
}

export const Route = createFileRoute('/_authed/search/')({
  validateSearch: (raw: Record<string, unknown>): SearchPageSearch => ({
    ...(pickStr(raw.q) !== undefined ? { q: pickStr(raw.q) as string } : {}),
    ...(parseType(raw.type) !== undefined
      ? { type: parseType(raw.type) }
      : {}),
  }),
  component: SearchPage,
});

function SearchPage() {
  return <SearchResultsBody />;
}
